import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { AuthService } from "../services/auth.service";

@Injectable({
    providedIn: "root",
})
export class AuthGuard implements CanActivate {
    constructor(private authService: AuthService, private router: Router) {}

    canActivate(): boolean {
        // Check if token is expired and handle it
        this.authService.checkTokenExpiration();

        if (!this.authService.isAuthenticated()) {
            this.router.navigate(["/login"]);
            return false;
        }

        // admin and super_admin are platform-level roles — they never need to create an entity
        if (this.authService.requiresEntityCreation() && !this.authService.isAdmin()) {
            this.router.navigate(["/auth/create-entity"]);
            return false;
        }

        return true;
    }
}
